import React from "react";
import _ from "lodash";

import { NetworkAPI } from "apis";
import LoadingUI from "../../../common/LoadingUI";
import NetworkInfoHeader from "../../common/NetworkInfoHeader";
import ReactJson from "@microlink/react-json-view";
import { getPrebidSummarySchema } from "./NetworkPrebidSchema";
import { getDataScehmaDiff } from "components/snapshot/NetworkResourceSchema";
import SimpleTooltip from "components/common/SimpleTooltip";
import ScrollToTop from "components/common/ScrollToTop";
import ConfigValueReadonly from "components/control-center/auto-pilot/config/ConfigValueReadonly";
import ClickToCopyButton from "components/common/ClickToCopyButton";
import { FiInfo } from "react-icons/fi";
import { buttonActionClassGray, inputClass } from "helpers/StyleClass";

class NetworkPrebidSummaryViewer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSaving: false,
      isLoading: false,

      networkId: null,
      networkInfo: null,
      errMsg: "",
      summary: null,
      schema: null,
      categoryList: [],
      isJsonView: true,
      searchInput: "",
    };
    this.toggleJsonView = this.toggleJsonView.bind(this);
    this.scrollToLabel = this.scrollToLabel.bind(this);
    this.handleUpdatePrebidCache = this.handleUpdatePrebidCache.bind(this);
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    const { networkId } = this.props.match.params;
    if (!networkId) {
      this.setState({ errMsg: "Missing Network ID" });
    } else {
      // document.title = `${networkId} Prebid Summary | YB Observer`;
      this.setState({ networkId });
    }

    const networkInfo = await NetworkAPI.getNetworkInfo({
      networkId,
    });
    this.setState({
      networkId,
      networkInfo,
    });

    try {
      const summary = await NetworkAPI.getPrebidSummary({ networkId });
      const schema = getPrebidSummarySchema();
      const diff = getDataScehmaDiff({
        data: summary,
        schema,
      });

      const groudedSchema = _.groupBy([...schema, ...diff], (s) => {
        return s.groupCategory || "Undefined";
      });

      this.setState({
        summary,
        schema: [...schema, ...diff],
        isLoading: false,
        categoryList: _.keys(groudedSchema),
      });
    } catch (err) {
      console.log(err);
      this.setState({
        isLoading: false,
        errMsg: err.toString(),
      });
    }
  }

  toggleJsonView() {
    this.setState({ isJsonView: !this.state.isJsonView });
  }

  async handleUpdatePrebidCache() {
    const { networkId } = this.state;
    if (!networkId) return;
    const userConfirm = window.confirm(
      `Update Prebid Cache for network ${networkId}? (This could take up to 15 minutes)`
    );
    if (!userConfirm) return;

    this.setState({ isTriggerLoading: true, updateCacheErrMsg: null });

    try {
      const r = await NetworkAPI.triggerUpdatePrebidCache({ networkId });
      console.log(r);

      window.alert(
        "Update prebid cache successfully triggered. Please wait about 15 min for it to finish updating."
      );

      this.setState({ isTriggerLoading: false });
    } catch (err) {
      this.setState({
        updateCacheErrMsg: typeof err !== "string" ? err.toString() : err,
        isTriggerLoading: false,
      });
    }
  }

  scrollToLabel(label) {
    const element = document.getElementById(label);

    if (element) {
      window.scrollTo({
        behavior: "auto",
        top: element.offsetTop - 56,
      });
    }
  }

  render() {
    const {
      networkInfo,

      isLoading,
      errMsg,
      summary,
      schema,
      categoryList,

      isJsonView,

      searchInput,
    } = this.state;

    const filteredSchema = (schema || []).filter((s) => {
      if (searchInput === "") {
        return true;
      }
      const searchKey = searchInput.toLowerCase();
      const configKey = (s.title || s.key).toLowerCase();
      return configKey.includes(searchKey);
    });

    const filterdCategorySchemas = _.groupBy(filteredSchema, (s) => {
      return s.groupCategory;
    });

    return (
      <div>
        {networkInfo && (
          <NetworkInfoHeader networkInfo={networkInfo}></NetworkInfoHeader>
        )}

        <div className="min-h-screen bg-gray-200 px-12 py-8">
          <div className="flex items-center justify-between">
            <PageTitle title="Network Prebid Summary"></PageTitle>
          </div>
          {isLoading && <LoadingUI></LoadingUI>}
          {errMsg && <div className="text-red-800">{errMsg}</div>}

          {summary && (
            <>
              <div className="flex w-full">
                <div className="w-3/4">
                  <div className="mb-1 mt-2 flex items-center justify-end">
                    <button
                      type="button"
                      className={buttonActionClassGray}
                      onClick={this.toggleJsonView}
                    >
                      {!isJsonView ? "View In JSON" : "View in table"}
                    </button>
                  </div>

                  {summary && (
                    <>
                      {isJsonView ? (
                        <div className="bg-white">
                          <ReactJson
                            src={summary}
                            name={false}
                            displayDataTypes={false}
                            theme={"monokai"}
                            enableClipboard={false}
                          ></ReactJson>
                        </div>
                      ) : (
                        <>
                          <div className="my-2 flex flex-wrap items-center gap-1 text-sm">
                            <div className="font-semibold text-gray-700">
                              Jump to:{" "}
                            </div>
                            {categoryList.map((category) => {
                              return (
                                <button
                                  key={category}
                                  type="button"
                                  className="border rounded border-gray-200 bg-white px-2 py-1 text-gray-800 hover:border-blue-400"
                                  onClick={() => {
                                    this.scrollToLabel(category);
                                  }}
                                >
                                  {category}
                                </button>
                              );
                            })}
                          </div>
                          <input
                            type="text"
                            className={`${inputClass} mb-2`}
                            placeholder="Search key"
                            onChange={(e) =>
                              this.setState({ searchInput: e.target.value })
                            }
                          ></input>
                          {categoryList.map((category) => {
                            const configSchemas =
                              filterdCategorySchemas[category];

                            return (
                              <div
                                key={category}
                                id={category}
                                className="mb-12"
                              >
                                <div className="border border-blue-200 bg-blue-100 py-2 pl-8 text-xl font-semibold text-blue-800">
                                  {`${category} Settings`}
                                </div>

                                <div className="border bg-white">
                                  {(configSchemas || []).map((s) => {
                                    // sectionConfigKey could be ""
                                    // use s.prefix!! (different than autopilot)
                                    const sectionConfigKey = s.prefix;
                                    const configValue = sectionConfigKey
                                      ? _.get(summary, [
                                          sectionConfigKey,
                                          ...s.key.split("."),
                                        ])
                                      : _.get(summary, s.key.split("."));
                                    const configKeyTitle =
                                      s.title || _.startCase(s.key);

                                    return (
                                      <div
                                        key={s.key}
                                        className="border-b flex border-gray-400"
                                      >
                                        <div className="w-1/3 py-4 pl-8">
                                          <div
                                            className={`break-words pr-4 text-sm font-semibold text-gray-800 ${
                                              s.isDeprecated
                                                ? "text-orange-700"
                                                : ""
                                            }`}
                                          >
                                            {s.title ? s.title : configKeyTitle}
                                            :
                                          </div>
                                          <div className="text-xs text-gray-600">
                                            {s.isUnitOnly
                                              ? "(Unit level only)"
                                              : ""}
                                          </div>
                                          {s.description &&
                                            s.description !== "" && (
                                              <SimpleTooltip
                                                place="right"
                                                tooltipText={
                                                  <div
                                                    style={{
                                                      maxWidth: "300px",
                                                    }}
                                                  >
                                                    <div>
                                                      <b>{configKeyTitle}:</b>
                                                    </div>
                                                    {s.description}
                                                  </div>
                                                }
                                              >
                                                <div className="mt-2 text-xs text-blue-600">
                                                  <FiInfo></FiInfo>
                                                </div>
                                              </SimpleTooltip>
                                            )}
                                        </div>

                                        <div className="group flex w-2/3 justify-between bg-gray-200 px-4 py-4">
                                          <div
                                            className="py-2"
                                            style={{
                                              width: "calc(100% - 80px)",
                                            }}
                                          >
                                            <div className="font-semibold text-blue-600">
                                              <ConfigValueReadonly
                                                valueType={s.valueType}
                                                configValue={
                                                  category === "Undefined"
                                                    ? JSON.stringify(
                                                        configValue
                                                      )
                                                    : configValue
                                                }
                                              ></ConfigValueReadonly>
                                            </div>
                                            <div className="text-sm text-gray-600">
                                              {s.unit}
                                            </div>
                                          </div>
                                          <div className="hidden group-hover:block">
                                            <ClickToCopyButton
                                              copyText={JSON.stringify(
                                                configValue
                                              )}
                                            ></ClickToCopyButton>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          })}
                        </>
                      )}
                    </>
                  )}
                </div>

                <div className="w-1/4 pl-4">{""}</div>
              </div>
              <div>
                <ScrollToTop></ScrollToTop>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

function PageTitle({ title }) {
  return <div className="text-3xl font-extrabold">{title}</div>;
}

export default NetworkPrebidSummaryViewer;
